export type AgentEditRange = {
  from: number;
  to: number;
};

export type AgentEditTarget =
  | {
      kind: 'document';
    }
  | {
      kind: 'targeted';
      range: AgentEditRange;
    };

export type AgentEditScope = AgentEditTarget['kind'];

export const createDocumentEditTarget = (): AgentEditTarget => ({
  kind: 'document',
});

export const createTargetedEditTarget = (range: AgentEditRange): AgentEditTarget => ({
  kind: 'targeted',
  range,
});

export const getAgentEditScope = (editTarget: AgentEditTarget): AgentEditScope => editTarget.kind;

export const getTargetedEditRange = (editTarget?: AgentEditTarget): AgentEditRange | undefined =>
  editTarget?.kind === 'targeted' ? editTarget.range : undefined;
